<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.loadDocument.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.loadDocument.description') }}
    </p>
    <div class="w-full radio-group">
      <zt-radio-button
          :value="'false'"
          v-model="selected"
          name="visible"
          @change="update"
          data-vs-radio-button="loadDocument"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.loadDocument.option.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
        {{ $t('message.abm.folders.settings.loadDocument.option.label') }}
      </span>
    </div>
    <div class="w-full">
      <zt-radio-button
          :value="'true'"
          v-model="selected"
          name="visible"
          @change="update"
          data-vs-radio-button="loadDocument"
      >
        <span class="custom-label"> {{ $t('message.abm.folders.settings.loadDocument.option1.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
         {{ $t('message.abm.folders.settings.loadDocument.option1.legend') }}
      </span>
    </div>
    <div class="mt-16" v-if="loadDocument">
      <h2 class="custom-title custom-color-gray font-medium mb-4">
        {{ $t('message.abm.folders.settings.loadDocument.question') }}
      </h2>
      <p class="custom-legend text-zt-dark-300 mb-4">
        {{ $t('message.abm.folders.settings.loadDocument.description1') }}
      </p>
      <div v-if="isLoading">
        <div class="w-full mt-3 flex">
          <div class="loader loader--circle animation--wave bg-zt-dark-200 mr-3"></div>
          <div class="group-line">
            <div class="loader loader--line animation--wave bg-zt-dark-200 mb-1"></div>
            <div class="loader loader--line animation--wave bg-zt-dark-200"></div>
          </div>
        </div>
        <div class="w-full mt-3 flex">
          <div class="loader loader--circle animation--wave bg-zt-dark-200 mr-3"></div>
          <div class="group-line">
            <div class="loader loader--line animation--wave bg-zt-dark-200 mb-1"></div>
            <div class="loader loader--line animation--wave bg-zt-dark-200"></div>
          </div>
        </div>
      </div>
      <div v-else
        v-for="(tmp, index) in templateLoadDocument"
        :key="index"
        class="w-full radio-group"
      >
        <zt-radio-button
          :value="tmp.id"
          v-model="selectedTemplateId"
          name="method"
          @change="updateTemplate"
          data-vs-radio-button="template"
        >
          <span class="custom-label">{{ tmp.alias }}</span>
        </zt-radio-button>
        <span class="radio-legend block text-zt-dark-300">
        {{ tmp.description }}
      </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubFolderLoadDocuments",
  inject: ['stateFolder', 'setSubFolderParams'],
  props: {
    templateLoadDocument: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: '',
      selectedTemplateId: '',
      loadDocument: false,
    }
  },
  computed: {
    isLoading() {
      return this.templateLoadDocument.length === 0
    }
  },
  methods: {
    update() {
      const isLoadDocument = (/^(true|1)$/i).test(this.selected) && !!this.selected
      if(isLoadDocument) {
        this.loadDocument = true
        this.selectedTemplateId = '1'
        this.setSubFolderParams({
          isLoadDocument: isLoadDocument,
          templateId: parseInt(this.selectedTemplateId),
          visible: true
        })
      } else {
        this.loadDocument = false
        this.setSubFolderParams({
          isLoadDocument: isLoadDocument,
          templateId: '',
          visible: false
        })
      }

    },
    updateTemplate() {
      this.setSubFolderParams({
        templateId: parseInt(this.selectedTemplateId),
      })
    }
  },
  created() {
    this.selected = this.stateFolder.subFolderParams.isLoadDocument.toString()
    this.selectedTemplateId = this.stateFolder.subFolderParams.templateId.toString()
    this.loadDocument = this.stateFolder.subFolderParams.isLoadDocument
  }
}
</script>

<style scoped lang="scss">
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.custom-color-gray {
  color: #575757;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
.loader {
  width: fit-content;
  cursor: wait;
}
.loader--circle {
  overflow: hidden;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  position: relative;
  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 60px;
    height: 24px;
  }
}
.group-line {
  width: calc(100% - 24px);
  position: relative;
}
.loader--line {
  overflow: hidden;
  width: 100%;
  height: 20px;
  position: relative;
  &:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 120%;
    height: 24px;
  }
}
.animation--wave::before {
  background: linear-gradient(115deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  animation: wave 1.5s linear .5s infinite;
}
@keyframes wave {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
